import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {ModalProgressBar} from "../../../../../../_metronic/_partials/controls";
import * as actions from "../../../_redux/customers/customersActions";
import {useCustomersUIContext} from "../CustomersUIContext";

export function CustomerDeleteDialog({ id, show, onHide }) {

     const history = useHistory()
  // Customers UI Context
  const authtoken = useSelector(state => state.user.authtoken)

  const customersUIContext = useCustomersUIContext();
  const customersUIProps = useMemo(() => {
    return {
      setIds: customersUIContext.setIds,
      queryParams: customersUIContext.queryParams
    };
  }, [customersUIContext]);

  // Customers Redux state
  const dispatch = useDispatch();
  const { isLoading } = useSelector(
    (state) => ({ isLoading: state.customers.actionsLoading }),
    shallowEqual
  );

  // if !id we should close modal
  useEffect(() => {
    if (!id) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // looking for loading/dispatch
  useEffect(() => {}, [isLoading, dispatch]);

  const deleteCustomer = () => {
   
  

      // console.log(id)
      fetch(`http://portal.darearqamsgd.edu.pk/api/vehicle/${id}`, {
          method: 'DELETE',
          headers: {
              // 'Accept': 'application/json',
              // 'Content-Type': 'application/json',
              'Authorization': `Bearer ${authtoken}`
          },
      }).then(res => res.json()
          .then(data => {
              if (data.metadata.success == true) {
                    onHide()  
                    history.push('/vehicle')              
              }
          })

      ).catch(err => {
          console.log(err)
      })
  

  
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {/*begin::Loading*/}
      {isLoading && <ModalProgressBar />}
      {/*end::Loading*/}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          Vehicle Delete
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!isLoading && (
          <span>Are you sure to permanently delete this Vehicle?</span>
        )}
        {isLoading && <span>Vehicle is deleting...</span>}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn  btn-danger btn_width"
          >
            Cancel
          </button>
          <> </>
          <button
            type="button"
            onClick={deleteCustomer}
            className="btn btn-primary btn-elevate"
          >
            Delete
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
